var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.083 15.153c0 4.669-3.824 8.454-8.542 8.454C3.824 23.607 0 19.822 0 15.153c0-4.669 3.824-8.454 8.541-8.454 4.718 0 8.542 3.785 8.542 8.454zM8.54 21.607c3.602 0 6.521-2.89 6.521-6.454 0-3.564-2.92-6.454-6.52-6.454-3.602 0-6.521 2.89-6.521 6.454 0 3.564 2.919 6.454 6.52 6.454z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.53 8c-.238-4.458-3.965-8-8.529-8-4.563 0-8.291 3.542-8.53 8h2.025c.236-3.353 3.058-6 6.505-6s6.27 2.647 6.505 6h2.024z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.098 23.451C27.031 22.694 30 19.267 30 15.153c0-4.669-3.824-8.454-8.542-8.454a8.559 8.559 0 00-6.699 3.21l1.146 1.86a6.532 6.532 0 015.553-3.07c3.602 0 6.521 2.89 6.521 6.454 0 3.4-2.657 6.186-6.028 6.435l1.147 1.863z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.48 22.142C6.79 26.532 10.486 30 15 30c4.718 0 8.542-3.785 8.542-8.453 0-4.368-3.345-7.961-7.638-8.408l.817.818-1.16 1.16c3.34.28 5.96 3.052 5.96 6.43 0 3.564-2.919 6.453-6.52 6.453-3.39 0-6.175-2.56-6.491-5.832L7.508 23.17 6.48 22.142z"
  })));
}
export default SvgLogoOutline;